
export enum SellActionType {
    Order,
    RFQ
}
